import React from "react";
import ContactForm from "../../forms/ContactForm";

const MessageUsSection = () => {
  return (
    <div className="my-24 lg:my-36 container mx-auto lg:w-[60%]">
      {/* <ContactForm /> */}
      <div className="my-24 container mx-auto">
        <h1 className="font-bold text-3xl text-primary-base text-center">
          Find us in Google Map
        </h1>
        <p className="text-gray-600 text-center mt-2">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet,
        </p>
        <div className="mt-8 text-center flex justify-center">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3531.9851772952666!2d85.32411811499605!3d27.71774393164199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb196dbd2b0f61%3A0xb394bc8610c6459!2sTrioPlus%20Technology%20Pvt.%20Ltd.!5e0!3m2!1sen!2snp!4v1662015368561!5m2!1sen!2snp"
            height="450"
            loading="lazy"
            className="w-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MessageUsSection;
